import { Route, Switch } from 'react-router-dom'

import { PrivateRoute } from 'core/ui/components/private-route/PrivateRoute'
import { PageNotFound } from 'core/ui/router/PageNotFound'

import { useConfigContext } from 'config/ui/ConfigContext'

import BidsPanel from '../bids/ui/BidsPanel'
import { PORTAL_BASE_PATH } from '../core/domain/PortalRoute'
import { PortalPage } from '../core/ui/PortalPage'
import RfpPage from '../rfp/ui/RfpPage'
import { ShipmentDetails } from '../shipments/ui/ShipmentDetails'
import { ShipperLoadsPage } from '../shipments/ui/ShipperLoadsPage'
import { ShippersPage } from '../shippers/ui/ShippersPage'
import SpotQuotePage from '../spot-quotes/ui/SpotQuotePage'
import { TenderPage } from '../tender/ui/TenderPage'

const BASE_PATH = PORTAL_BASE_PATH

export default function ShipperGuide() {
  const { enableShipperListPage } = useConfigContext()

  return (
    <Switch>
      <Route path={`${BASE_PATH}/shipment/:shipmentUUID/:section?`}>
        <PortalPage urlTokenKind="agnostic">
          <ShipmentDetails />
        </PortalPage>
      </Route>
      <PrivateRoute path={`${BASE_PATH}/shipments`} exact>
        <PortalPage>
          <ShipperLoadsPage />
        </PortalPage>
      </PrivateRoute>
      <PrivateRoute path={`${BASE_PATH}/bids-list`} exact>
        <PortalPage>
          <BidsPanel />
        </PortalPage>
      </PrivateRoute>
      <Route
        path={`${BASE_PATH}/bids/spot-quote`}
        render={props => (
          <PortalPage>
            <SpotQuotePage {...props} />
          </PortalPage>
        )}
      />
      <Route
        path={`${BASE_PATH}/tender/:id`}
        render={props => (
          <PortalPage urlTokenKind="agnostic">
            <TenderPage {...props} />
          </PortalPage>
        )}
      />
      <Route
        path={`${BASE_PATH}/rfp`}
        render={props => (
          <PortalPage urlTokenKind="agnostic">
            <RfpPage {...props} />
          </PortalPage>
        )}
      />
      {enableShipperListPage.toBoolean() && (
        <PrivateRoute path={`${BASE_PATH}/shippers`}>
          <PortalPage>
            <ShippersPage />
          </PortalPage>
        </PrivateRoute>
      )}
      <Route path="*">
        <PortalPage>
          <PageNotFound />
        </PortalPage>
      </Route>
    </Switch>
  )
}
